import { FC, useState } from 'react';
import { Grid } from '@mui/material';
import { DashboardTitle } from 'components/Titles';
import { Formik } from 'formik';
import { vetSignUpValidation } from 'schemas';
import { VetSignUpForm } from 'components/Forms';
import { VetService } from 'services/vet.service';

interface IVetSignUp {
  name: string;
  birthday: Date | any;
  cpf: string;
  gender: string;
  email: string;
  phone: string;
  crmv: string;
  uf: string;
  specialization: string;
  idDoc: {};
  bond: string;
  counselorCard: {};
}

const initialValues: IVetSignUp = {
  name: '',
  birthday: '',
  cpf: '',
  gender: '',
  email: '',
  phone: '',
  crmv: '',
  uf: '',
  specialization: '',
  idDoc: {},
  bond: 'internal',
  counselorCard: {},
};

export const VetSignUp: FC = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string>('');
  const [success, setSuccess] = useState<string>('');

  const handleSubmit = async (values: IVetSignUp) => {
    const newValues = { ...values };
    newValues.cpf = newValues.cpf.replaceAll('.', '').replace('-', '');
    if (values.birthday === '') {
      newValues.birthday = new Date(1900, 0, 0).toISOString();
    } else {
      newValues.birthday = new Date(values.birthday).toISOString();
    }
    const isValid = await vetSignUpValidation.isValid(newValues);
    setLoading(true);

    if (isValid) {
      VetService.signUpVet(newValues).then(
        () => {
          setLoading(false);
          setError('');
          setSuccess('Veterinário cadastrado com sucesso');
          window.location.reload();
        },
        ({ response }) => {
          setLoading(false);
          setSuccess('');
          setError(response.data.error);
        }
      );
    }
  };

  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <DashboardTitle title="CADASTRAR VETERINÁRIO" />
      </Grid>
      <Grid item xs={12}>
        <Formik
          initialValues={initialValues}
          validationSchema={vetSignUpValidation}
          onSubmit={handleSubmit}
        >
          <VetSignUpForm loading={loading} error={error} success={success} />
        </Formik>
      </Grid>
    </Grid>
  );
};
